// Helpers

const convertToIntegerValue = value => {
  const parts = value.split(':')

  if (parts.length < 2) {
    return null
  }

  const hours = Number(parts[0])
  const minutes = Number(parts[1])

  return hours * 60 + minutes
}

const convertToTimeInputFormat = value => {
  const hoursInteger = Math.floor(value / 60)
  const minutesInteger = value % 60

  const hoursString = String(hoursInteger).padStart(2, '0')
  const minutesString = String(minutesInteger).padStart(2, '0')

  return `${hoursString}:${minutesString}`
}

// Exports

export const convertToTimeInputValue = (value, defaultValue) => {
  // Mirror the current product experience and `nil` out the value if:
  // - The user selects a max value equal to the maximum range
  // - The user selects a min value equal to the minimum range
  if (value === defaultValue) {
    return ''
  }

  return convertToTimeInputFormat(value)
}

export const maybeConvertToIntegerValue = (value, defaultValue) => {
  if (Number.isInteger(value)) {
    return value
  }

  if ((value && typeof value === 'string') || value instanceof String) {
    return convertToIntegerValue(value) || defaultValue
  }

  return defaultValue
}
